import React, { useState, useEffect } from 'react'
import messages from './messages'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { Icon, Button, DropdownMenu, Chip } from '@arnsbogroup/react-voicearchive'
import useApi from 'hooks/useApi'
import classNames from 'classnames'
import NiceModal from '@ebay/nice-modal-react'
import UsageTaskModeModal from '../UsageTaskModeModal'
import SelectUsageBaseTaskModal from '../SelectUsageBaseTaskModal'
import { getUsageChainTails } from 'utils/usageChainHelpers'
import useCurrentUser from 'hooks/useCurrentUser'

export default ({ order, version, refetch, buttonProps = {} }) => {
  const { features = [] } = useCurrentUser()
  const history = useHistory()
  const [loading, setLoading] = useState(false)

  const [types,,, loadTypes] = useApi(`/rest/v2/ordertasktype?pageSize=10000`, { load: false })

  const USAGE_TYPE_ID = types?.find(t => t.shortname == 'USAGE')?.uid || 12

  const createTask = (typeId, usageParentTaskId = null) => {
    setLoading(true)

    const body = new FormData()
    body.append('orderid', order.uid)
    body.append('parentid', version.uid)
    body.append('typeId', typeId)

    if (usageParentTaskId) {
      body.append('usage_parenttask_uid', usageParentTaskId)
    }

    return fetch(`/ordertask/createdefaulttask.json`, { method: 'POST', body })
      .then((response) => response.json())
      .then(({ taskid }) => history.push(`/orders/${order.uid}/jobs/${version.parenttask}/versions/${version.uid}/tasks/${taskid}`))
      .then(() => setLoading(false))
      .then(refetch)
      .catch((error) => {
        toastr.error(error)
        setLoading(false)
      })
  }

  const onSubmit = async (typeId) => {
    if (typeId === USAGE_TYPE_ID) {
      const usageChainTails = getUsageChainTails(version.tasks || [], USAGE_TYPE_ID)

      if (usageChainTails.length > 0) {
        try {
          const { mode } = await NiceModal.show(UsageTaskModeModal, { existingUsageTasks: usageChainTails })

          if (mode == 'extension') {
            const { baseTaskId } = await NiceModal.show(SelectUsageBaseTaskModal, {
              existingUsageTasks: usageChainTails
            })

            return createTask(typeId, baseTaskId)
          }
        } catch (error) {
          return
        }
      }
    }

    return createTask(typeId, null)
  }

  return (
    <DropdownMenu
      button={{
        variant: 'inline',
        disabled: loading,
        className: "opacity-0 group-hover:opacity-100",
        children: loading ? 'Creating..' : '+ Task',
        onClick: loadTypes,
        ...buttonProps,
      }}
      items={!types ? [{ children: 'Loading...' }] : types.map(({ uid, name }) => ({
        children: `+ ${name}`,
        onClick: () => onSubmit(uid),
      })) || []}
    />
  )
}
